/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - SET THEME: STYLES --------------- ++++++++++ */
export default theme => ({
  settheme: {
    '& .name-setthemebutton': {
      width: 'auto',
      background: '#FFF',
      border: '1px solid #061240 !important'
    }
  }
});
